// Carriers with details
export const CARRIERS = {
  royal_mail: { id: 'royal_mail', name: 'Royal Mail', color: '#E74C3C', maxWeight: 10, maxBoxes: 5, conditions: 'Single box ≤10kg (20kg NI), max 61x46x46cm', url: 'https://send.royalmail.com/login?returnUrl=%2F' },
  parcelforce: { id: 'parcelforce', name: 'ParcelForce', color: '#3498DB', maxWeight: 30, conditions: 'Up to 30kg, max 150cm longest side', url: 'https://send.parcelforce.com' },
  fedex: { id: 'fedex', name: 'FedEx', color: '#4D148C', conditions: 'Heavy/multiple boxes with printer', url: 'https://www.fedex.com/shippingplus/en-gb/' },
  shiply: { id: 'shiply', name: 'Shiply', color: '#F1C40F', conditions: 'Large/bulky items >70kg or >150cm', url: 'https://www.shiply.com/listings/user_active' },
  // Not a carrier: the "Deliver in person" swimlane (spec_20260805). The
  // customer brings the items to the warehouse on a booked day/slot; the
  // lane-name link opens the availability calendar instead of a portal.
  warehouse_dropoff: { id: 'warehouse_dropoff', name: 'Deliver in person', color: '#3BB273', conditions: 'Customer brings items to the warehouse', url: '/deals/warehousedropoff' }
}

// Format number with leading zero and decimal places
export function formatNumber(value) {
  if (value === null || value === undefined || value === '') return '0'
  const num = parseFloat(value)
  if (isNaN(num)) return '0'
  // Ensure leading zero for decimals like .7 -> 0.7
  return num.toFixed(1).replace(/\.0$/, '')
}
